import { render } from "./swipe-stepper.html?vue&type=template&id=63757a38&scoped=true&ts=true&external"
import script from "./swipe-stepper.ts?vue&type=script&lang=ts&external"
export * from "./swipe-stepper.ts?vue&type=script&lang=ts&external"

import "./swipe-stepper.scss?vue&type=style&index=0&id=63757a38&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63757a38"]])

export default __exports__